<template>
  <div class="modal-content-poll">
    <div class="modal-header">
      <h2>Novo glasanje</h2>
    </div>
    <div class="body">
      <form class="form--mod" action="post">
        <div id="first-section">
          <div id="question-area">
            <label class="col-form-label col-form-label-lg">Pitanje</label>
            <textarea
              v-model="question"
              class="form-control"
              rows="5"
              id="comment"
              placeholder="Napišite pitanje"
              @focus="errorOccurred = false"
              ref="questionArea"
            ></textarea>
          </div>
          <div id="upload-area">
            <upload-button
              @files-selected="getFiles"
              ref="uploadBtn"
            ></upload-button>
            <div
              id="uploaded-files"
              :class="{ 'pointer-cursor': files.length == 0 }"
              @click="addFile"
              @dragover.prevent
              @dragleave.prevent
              @drop="onDrop"
            >
              <div class="upload-wrapper" v-if="files.length == 0">
                <svg
                  class="upload-icon pointer-cursor"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="33"
                  viewBox="0 0 50 43"
                >
                  <path
                    d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                  />
                </svg>
                <label class="upload-text pointer-cursor"
                  >Izaberite datoteku</label
                >
              </div>
              <!-- <div id="empty-files" v-if="files.length == 0">
                <p>Trenutno nemate dodatih datoteka</p>
              </div>-->
              <div class="file" v-for="(file, index) of files" :key="index">
                <p>{{ file.name }}</p>
                <i
                  class="fas fa-times del--mod"
                  @click="removeUploadedFile(index)"
                ></i>
              </div>
              <div
                class="upload-more-wrapper pointer-cursor"
                @click="addMoreFiles"
                v-if="files.length > 0"
              >
                <svg
                  class="upload-more-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 43"
                >
                  <path
                    d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                  />
                </svg>
                <span class="upload-more-text">Dodaj datoteku</span>
              </div>
            </div>
          </div>
        </div>

        <label class="col-form-label col-form-label-lg">
          Možete uneti najviše
          <b>četiri</b> opcije za glasanje
        </label>
        <div class="questions">
          <div
            class="new-options"
            v-for="(option, index) in options"
            :key="index"
          >
            <input
              v-model="option.option"
              placeholder="Unesite opciju"
              class="form-control form-control-lg"
              :id="index"
              @focus="errorOccurred = false"
            />
            <i
              v-if="minusVisible"
              class="far fa-minus-square minus--mod"
              @click="removeOption(index)"
            ></i>
          </div>

          <i
            class="far fa-plus-square"
            v-if="plusVisible"
            id="plus-button"
            @click="addNewOption"
          ></i>
        </div>

        <br />
        <label class="col-form-label col-form-label-lg"
          >Izaberite datum završetka glasanja</label
        >
        <datetime
          @focus="errorOccurred = false"
          v-model="date"
          type="datetime"
          input-class="form-control form-control-lg"
          placeholder="Izaberite datum"
          hidden-name="webstorm"
          value-zone="UTC+1"
          format="dd.MM.yyyy HH:mm:ss"
          :phrases="{
            ok: 'U redu',
            cancel: 'Otkaži'
          }"
          :min-datetime="minDate"
          :max-datetime="maxDate"
        ></datetime>
      </form>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="submitMedia"
          :disabled="loading"
        >
          <span v-if="!loading">Pošalji</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Datetime } from 'vue-datetime';
import { DateTime } from 'luxon';
import 'vue-datetime/dist/vue-datetime.css';
import { Settings } from 'luxon';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';
import axios from '@/axios/axios.js';
import { mapMutations, mapActions, mapState } from 'vuex';

Settings.defaultLocale = 'sr-Latn';

export default {
  components: {
    Datetime,
    uploadButton
  },
  data() {
    return {
      minDate:
        DateTime.fromObject(new Date())
          .toFormat('yyyy-MM-dd HH:mm:ss')
          .split(' ')[0] +
        'T' +
        DateTime.fromObject(new Date())
          .toFormat('yyyy-MM-dd HH:mm:ss')
          .split(' ')[1],
      maxDate: '2030-05-24T12:12:12',
      files: [],
      date: '',
      errorOccurred: false,
      errorMessage: '',
      question: '',
      options: [
        {
          option: '',
          id: '',
          stats: ''
        },
        {
          option: '',
          id: '',
          stats: ''
        }
      ],
      minusVisible: false,
      plusVisible: true,
      removingFile: false
    };
  },
  computed: {
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getPollsByCommunity']),
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    addFile() {
      if (this.files.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
      return;
    },
    getFiles(load) {
      for (let l of load) {
        this.files.push(l);
      }
    },
    addNewOption() {
      if (this.options.length == 3) {
        this.plusVisible = false;
      }
      this.options.push({
        option: '',
        id: '',
        stats: ''
      });
      if (this.options.length > 2) {
        this.minusVisible = true;
      }
    },
    removeOption(index) {
      this.options.splice(index, 1);
      if (this.options.length < 3) {
        this.minusVisible = false;
      }
      if (this.options.length < 4) {
        this.plusVisible = true;
      }
    },
    validateInput() {
      if (this.question == '') {
        this.errorMessage = 'Ne možete uneti prazno pitanje';
        return false;
      }
      if (this.question.length > 1000) {
        this.errorMessage = 'Pitanje ne može imati preko 1000 karaktera';
        return false;
      }
      for (let o of this.options) {
        if (o.option == '') {
          this.errorMessage = 'Ne možete uneti praznu opciju';
          return false;
        }
        if (o.option.length > 100) {
          this.errorMessage = 'Opcija ne može imati preko 100 karaktera';
          return false;
        }
      }

      let uniqueOptions = new Set(this.options.map(e => e.option));
      if (uniqueOptions.size !== this.options.length) {
        this.errorMessage = 'Ne možete uneti dve iste opcije';
        return false;
      }
      if (this.date == '') {
        this.errorMessage = 'Morate uneti datum završetka glasanja';
        return false;
      }
      if (new Date(this.date) <= new Date()) {
        this.errorMessage = 'Datum mora biti u budućnosti';
        return false;
      }

      return true;
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.files.push(...files);
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.files.splice(index, 1);
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    submitMedia() {
      if (this.loading) {
        return;
      }

      this.errorOccurred = false;

      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }

      if (this.files.length == 0) {
        this.submitForm();
        return;
      }

      axios
        .post('/media/add', this.formatMediaForSubmit(), {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({ data }) => {
          this.submitForm(data);
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        fd.append('files[]', this.files[i], this.files[i].name);
      }
      fd.append('type', 'community');
      fd.append(
        'community_id',
        this.$store.getters.getActiveCommunity.community_id
      );
      return fd;
    },
    submitForm(data) {
      let votingData = {
        closesAt: DateTime.fromISO(this.date).toFormat('yyyy-MM-dd HH:mm:ss'),

        // closes_at: this.date,

        firstOption: this.options[0].option.trim(),
        firstOptionStats: '',
        idOfFirstOption: '',

        secondOption: this.options[1].option.trim(),
        secondOptionStats: '',
        idOfSecondOption: '',

        thirdOption:
          this.options[2] == null ? '' : this.options[2].option.trim(),
        thirdOptionStats: '',
        idOfThirdOption: '',

        fourthOption:
          this.options[3] == null ? '' : this.options[3].option.trim(),
        fourthOptionStats: '',
        idOfFourthOption: '',

        memberVotedFor: ''
      };

      let postData = {
        body: this.question,
        community_id: this.$store.getters.getActiveCommunity.community_id,
        direct_post_receiver_id: 0,
        event: null,
        media_ids: data == null ? '' : data.ids,
        member_id: this.$store.getters.getActiveCommunity.member_id,
        parent_post_id: 0,
        post_type: 2,
        voting: votingData
      };

      this.loadingStarted();

      axios
        .post('/post', postData)
        .then(() => {
          this.loadingFinished();
          if (this.$store.state.table.pollsFilter) {
            this.getPollsByCommunity({
              communityId: this.$store.getters.getActiveCommunity.id,
              memberId: this.$store.getters.getActiveCommunity.member_id
            });
          } else {
            this.getPollsByCommunity({
              communityId: this.$route.params.id
            });
          }

          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loadingFinished();
          if (error.response.data && error.response.data.messages) {
            this.showFailModal(error.response.data.messages);
          } else {
            this.showFailModal();
          }
        });
    }
  }
};
</script>

<style lang="scss">
.modal-content-poll {
  .body {
    height: 100%;
    width: 100%;
  }
  .upload-more-wrapper {
    width: 100%;
  }
  .form--mod {
    justify-content: center;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }
  .buttons {
    display: inline-flex;
    float: right;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    vertical-align: center;
    p {
      max-width: 155px;
      word-wrap: break-word;
      margin-bottom: 2px;
    }
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  textarea.form-control {
    resize: none;
    width: 100%;
  }

  #question-area {
    width: 66%;
  }

  #first-section {
    display: inline-flex;
    width: 100%;
    height: 100%;
  }

  .vdatetime-popup__header {
    background: var(--primary-color);
  }

  .del--mod {
    margin-left: auto;
    /*margin-right: 0;*/
    cursor: pointer;
    color: red;
    top: 4.7em;
    right: 1.7em;
  }

  #empty-files {
    text-align: center;
    color: grey;
    margin-top: 20%;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: var(--primary-color);
  }

  .vdatetime-popup__actions__button {
    color: var(--primary-color);
  }

  .vdatetime-time-picker__item--selected {
    color: var(--primary-color);
  }

  .vdatetime-month-picker__item--selected {
    color: var(--primary-color);
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  #plus-button {
    font-size: 25px;
    margin-bottom: 5px;
    transition: color 0.25s;
  }

  #add-file-label {
    display: inline-flex;
  }

  #add-file-label:hover {
    display: inline-flex;
    cursor: pointer;
    color: var(--primary-color);
    transition: color 0.25s;
  }

  #plus-button:hover {
    cursor: pointer;
    color: var(--primary-color);
  }

  .questions {
    text-align: center;
  }

  #uploaded-files {
    border: 1px dotted var(--primary-color);
    border-radius: 0.25rem;
    height: 135px;
    resize: none;
    max-height: 134px;
    overflow-y: auto;
    padding: 5px;
  }

  .new-options {
    display: flex;
    align-items: center;
  }
  .minus--mod {
    margin-left: 5px;
    font-size: 17px;
    color: grey;
    transition: color 0.25s;
  }

  #upload-area {
    display: block;
    margin-left: 9px;
    width: 34%;
    height: 100%;
  }

  .minus--mod:hover {
    cursor: pointer;
    color: #ff837b;
  }
  .err-msg {
    text-align: center;
    color: red;
  }
  .form-control {
    margin-left: 2px;
  }
}
</style>
